(function () {
  'use strict';

  angular
    .module('events.deposits.list')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('events.deposits.list', {
        url: '?q&p',
        params: {
          q: {
            value: '',
            squash: true
          },
          p: {
            value: '1',
            squash: true
          }
        },
        reloadOnSearch: false,
        templateUrl: 'events/vehicles/deposits/list/list.tpl.html',
        controller: 'DepositsListCtrl',
        controllerAs: 'vm'
      })
    ;
  }
}());
